import { render, staticRenderFns } from "./AboutTheWard.vue?vue&type=template&id=1acd05fe&scoped=true&"
import script from "./AboutTheWard.vue?vue&type=script&lang=js&"
export * from "./AboutTheWard.vue?vue&type=script&lang=js&"
import style0 from "./AboutTheWard.vue?vue&type=style&index=0&id=1acd05fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acd05fe",
  null
  
)

export default component.exports